export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8238.96854a47.jpg";